import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, SectionTag } from "./Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { fetchFaqs } from "@/lib/api";
import Seo, { faqJsonLd } from "./Seo";

export default function FAQ() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => { fetchFaqs(lang).then((r) => setItems(r.data)).catch(() => {}); }, [lang]);
  if (items.length === 0) return null;

  return (
    <section id="faq" className="relative section-pad" data-testid="faq-section">
      <Seo jsonLd={faqJsonLd(items)} jsonLdId="seo-jsonld-faq" />
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="text-center mb-12">
          <Reveal><div className="flex justify-center"><SectionTag>{t.faq.tag}</SectionTag></div></Reveal>
          <Reveal delay={0.05}><h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mt-5 mb-4">{t.faq.title}</h2></Reveal>
          <Reveal delay={0.1}><p className="text-slate-400 text-base sm:text-lg leading-relaxed">{t.faq.subtitle}</p></Reveal>
        </div>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3" dir="auto">
            {items.map((f, i) => (
              <AccordionItem key={f.id} value={`item-${i}`} className="card-surface rounded-2xl px-6 border-0" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-base font-bold hover:no-underline py-5 [&>svg]:text-primary">
                  <span className="text-start pe-3">{f.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 leading-relaxed text-base">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
